<template>
  <div class="home-message">
    <div v-for="item in messageList" :key="item.id" class="message-content" @click="toMessageDetail(item.id)">
      <div class="detail">
        <div class="title">
          <div class="titleone">{{ item.title | ellipsisFilter(50) }}</div>
          <div class="dataClass">
            {{ item.publishDate | dateFilter("timeTwo") }}
          </div>
        </div>
        <div class="slot"></div>
        <div class="titleBody">{{ item.textContent }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomeMessage",
  props: {
    headerTitle: String,
    messageList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {},
  methods: {
    toMessageDetail(id) {
      this.$router.push(
          "/messagedetail?id=" + id + "&headerTitle=" + this.headerTitle
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
.home-message >>> .van-tag {
  position: absolute;
  top: 10px;
  left: 0;
  font-size: 16px;
  line-height: 21px;
  height: 21px;
  padding: 10px 20px;
  border-radius: 8px;
  margin-left: 10px;
}

.dataClass {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #999999;
}

.message-content {
  margin-bottom: 32px;
  position: relative;

  .detail {
    box-sizing: border-box;
    padding: 32px 24px;
    background-color: #fff;
    border-radius: 16px 16px 16px 16px;
    box-shadow: 0 0 0.05rem 0 rgba(138, 135, 149, 0.2);

    .slot {
      width: 100%;
      height: 2px;
      background: #F4F3F8;
      border-radius: 0px 0px 0px 0px;
      margin: 24px 0;
    }

    .title {
      display: flex;
      justify-content: space-between;
      font-size: 28px;
      font-weight: 500;
      line-height: 1.5;
      color: rgba(51, 51, 51, 1);
      height: 70px;
      line-height: 70px;
    }

    .titleone {
      // width: 65%;
      width: 4.5rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
    }

    .titleBody {
      line-height: 0.5rem;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: 0.04rem;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #999999;
    }

    .date {
      padding-top: 20px;
      font-size: 18px;
      line-height: 1.5;
      color: rgba(102, 102, 102, 1);
      display: flex;
      justify-content: space-between;

      img {
        width: 0.4rem;
        height: 0.25rem;
      }

      .infoClass {
        display: flex;
        width: 1rem;

        span {
          margin: 0 0.2rem;
        }
      }

      .dateOne {
        display: flex;

        p {
          width: 2.3rem;
        }
      }
    }
  }

  img {
    height: 320px;
    width: 100%;
    border-radius: 10px 10px 0px 0px;
  }
}
</style>
